export const TIPS_VERSION = "2026-07-configurable-tips-1";
